"use client";

import { useQuery } from "@tanstack/react-query";
import { ComboboxDemo } from "../combobox";
import { useState } from "react";

export default function ApiFilter({
  filterKey,
  filters,
  setFilters,
  fetchFn,
  labelJoinKey = " ",
  valueKey = "id",
  labelKey = ["first_name", "last_name"],
  placeholder = "Select...",
  searchPlaceholder = "Search...",
  dependsOn = true,
  apiParams = {},
  className = "",
  disabled,
  onChange,
  icon,
  transformer,
}) {
  const [search, setSearch] = useState("");
  const queryKey = [filterKey, search, dependsOn, apiParams];

  function defaultTransformer(item) {
    return {
      value: item[valueKey],
      select: labelKey
        .map((key) => {
          return item[key] || "";
        })
        .join(labelJoinKey)
        .trim(),
      label: labelKey
        .map((key) => {
          return item[key] || "";
        })
        .join(labelJoinKey)
        .trim(),
      originalData: item,
    };
  }

  const { data: options = [], isLoading } = useQuery({
    queryKey,
    queryFn: async () => {
      const data = await fetchFn(search, { ...apiParams });
      return data.map(transformer || defaultTransformer);
    },
    enabled: !!dependsOn,
  });

  const currentSelectedItem = filters?.[filterKey]?.__selectedItem;

  return (
    <ComboboxDemo
      data={options}
      selectedItem={currentSelectedItem}
      onChange={onChange}
      onSearch={setSearch}
      placeholder={placeholder}
      searchPlaceholder={searchPlaceholder}
      className={className}
      disabled={disabled}
      isLoading={isLoading}
      icon={icon}
    />
  );
}
